// pdf.js (Mozilla) carregado sob demanda: o pacote só é baixado quando alguém abre
// um manual. O worker roda na própria página (pdf.worker.entry põe o handler em
// window.pdfjsWorker): sem arquivo extra em public/ nem loader de webpack, e o
// manual tem poucas páginas. isEvalSupported:false fecha o eval de fontes do pdf.js.
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.
export async function abrirPdf(dados) {
  const [pdfjs] = await Promise.all([
    import("pdfjs-dist/legacy/build/pdf"),
    import("pdfjs-dist/legacy/build/pdf.worker.entry"),
  ]);
  const lib = pdfjs && pdfjs.getDocument ? pdfjs : pdfjs.default;
  return lib.getDocument({ data: dados, isEvalSupported: false }).promise;
}
